import t from 'react-translate';
import { css } from '@emotion/react';
import { map } from 'underscore';
import { useState } from 'react';

import { AiSuggestedComponentProps } from 'redux/schemas/models/ai-course-creation';
import { ComponentType, LectureComponent } from 'redux/schemas/models/lecture-component';
import { AllQuestionViewQuiz } from 'redux/schemas/models/all-question-view-quiz';

import { largeSpacing } from 'styles/global_defaults/scaffolding';
import { gray5, gray7 } from 'styles/global_defaults/colors';

import NvIcon from 'shared/components/nv-icon';
import ClickableContainer from 'components/clickable-container';
import { getAlphabetCharacter } from 'quizzes/components/utils';

const styles = css`
  .question-card {
    .question-no {
      background-color: ${gray7};
      min-width: ${largeSpacing}px;
      height: ${largeSpacing}px;
      border-radius: 4px;
      border: 1px solid ${gray5};
      font-weight: 700;
    }

    .question-text > .froala-style-medium {
      font-weight: 700 !important;
    }
  }
`;

const QuizQuestions = ({ componentSet }: AiSuggestedComponentProps) => {
  const [expanded, setExpanded] = useState(false);
  const activity = componentSet.activity as LectureComponent<ComponentType.QUIZ>;
  // Here the type is TimelineQuiz, so Cast the quiz to the correct type
  const quiz = activity.quiz as AllQuestionViewQuiz;

  // Only show first question if not expanded
  const visibleQuestions = expanded ? quiz.questions : quiz.questions.slice(0, 1);

  return (
    <div className='d-flex flex-column mt-4' css={styles}>
      {visibleQuestions.map((question, i) => (
        <div className='question-card d-flex mb-4' key={question.id}>
          <div className='question-no d-flex align-items-center justify-content-center text-large-body'>
            {i + 1}
          </div>
          <div className='d-flex flex-column pl-2'>
            <div
              className='question-text'
              dangerouslySetInnerHTML={{ __html: question.questionText }}
            />
            <div className='options d-flex flex-column text-large-body'>
              {map(question.responseOptions, (option, index) => (
                <div className='d-flex' key={`${option.optionContent}-${index}`}>
                  <span>{getAlphabetCharacter(index)}.</span>
                  <div className='pl-1'>{option.optionContent}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
      {quiz.questions.length > 1 && (
        <ClickableContainer
          onClick={() => setExpanded((prev) => !prev)}
          className='d-flex align-items-center text-primary'
          aria-label={t.SHARED[expanded ? 'VIEW_LESS' : 'VIEW_MORE']()}
        >
          <span className='mr-1'>
            {t.SHARED[expanded ? 'VIEW_LESS' : 'VIEW_MORE']()}
          </span>
          <NvIcon
            icon={expanded ? 'arrow-up' : 'arrow-down'}
            size='xs-smallest'
          />
        </ClickableContainer>
      )}
    </div>
  );
};

export default QuizQuestions;
